/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  Container,
  ContainerView,
} from "../../components/Container";
import { useApp } from "../../contexts";
import { CardSlideHeader } from "../../components/CardSlideHeader";
import TabsCustom from "../../components/TabsCustom";
import { Tabs, Tooltip } from "antd";
import { TabWallet } from "./components/TabWallet";
import { InfoTooltipIcon, SlideBannerContainer, SwiperWraper } from "./styles";
import { SwiperSlide } from "swiper/react";
import { useWindowSize } from "../../hook/useWindowSize";
import { TabAsset } from "./components/TabAsset";
import { getInfoDashboard } from "../../services/app";
import { bannerIcon } from "../../constants";
import {
  formatNumberShort,
  replaceString,
  getBatchRunDate,
} from "../../utils/helper";
import { HomeGuide } from "./components/HomeGuild";
import { TabEarn } from "./components/TabEarn";
import NumberFormat from "react-number-format";
import { baseCurrencyCode, decimalScaleByCurrency, decimalSeparatorByCurrency, prefixCcySymbol, thousandSeparatorByCurrency } from "../../utils/Currency";

export const TabHomeOption = {
  wallet: "wallet",
  asset: "asset",
  earn: "earn",
};

export const DASHBOARD_REPORTS = {
  EST_BALANCE: "EST_BALANCE",
  TOTAL_ACCESS_VALUE: "TOTAL_ACCESS_VALUE",
  TOTAL_COMMISION: "TOTAL_COMMISION",
  TOTAL_EARNING: "TOTAL_EARNING",
}

export const PREPOSITION = {
  HOME_ASSET: "home-asset",
  EARNER: "earner",
  CHARACTER: "character",
}

export const PREPOSITIONS = [
  PREPOSITION.HOME_ASSET,
  PREPOSITION.EARNER,
  PREPOSITION.CHARACTER,
]

export const Home = () => {
  const {
    T,
    user,
    convertToCurrency,
    currency,
    getCurrency,
    isMobile,
    setLoading,
    setPrePosition,
    prePosition,
    currencyRates,
  } = useApp();
  const [tab, setTab] = useState(TabHomeOption.wallet);
  const size = useWindowSize();
  const [dataDashboard, setDataDashboard] = useState();
  const [swiper, setSwiper] = React.useState(null);
  const nexto = (index) => swiper.slideTo(index);

  const getSlidePreview = () => {
    let preview = 0.8;
    if (size.width >= 1280) {
      preview = 3;
    } else if (size.width >= 1024) {
      preview = 2.4;
    } else if (size.width >= 890) {
      preview = 3;
    } else if (size.width >= 576) {
      preview = 2.3;
    } else if (size.width >= 400) {
      preview = 1.31;
    } else if (size.width >= 340) {
      preview = 1.26;
    } else if (size.width >= 320) {
      preview = 1.1;
    }
    return preview;
  };
  const getSpaceBeetween = () => {
    let distance = 30;
    if (size.width < 1024) {
      distance = 20;
    }
    return distance
  }
  useEffect(() => {
    if (PREPOSITIONS.includes(prePosition)) {
      setTab(TabHomeOption.asset);
    }
  }, [prePosition]);

  const handleTab = (tab) => {
    if (tab === TabHomeOption.asset) {
      setPrePosition(PREPOSITION.HOME_ASSET);
    }
    setTab(tab);
    nexto(Object.values(TabHomeOption).indexOf(tab));
  };

  useEffect(() => {
    setLoading(true);
    getInfoDashboard()
      .then((res) => {
        const data = res?.data?.data;
        if (data) {
          const reports = data.reports
            ?.filter(r => r.key !== "TOTAL_COMMISION")
            ?.map((report) => {
              switch (report.key) {
                case DASHBOARD_REPORTS.EST_BALANCE:
                  report.code = TabHomeOption.wallet;
                  report.title = "Est. Balance";
                  break;
                case DASHBOARD_REPORTS.TOTAL_EARNING:
                  report.code = TabHomeOption.earn;
                  report.title = "Est. Earning Amount";
                  break;
                case DASHBOARD_REPORTS.TOTAL_ACCESS_VALUE:
                    report.code = TabHomeOption.asset;
                    report.title = "Total profitable assets";
                    break;
                case DASHBOARD_REPORTS.TOTAL_COMMISION:
                  report.code = TabHomeOption.affilate;
                  report.title = "Unrealized Commission";
                  break;
                default:
                  break;
              }
              return report;
            });
          const wallets = {};
          if (!data?.wallets?.cryptos?.length) {
            const rate = currencyRates?.find(
              (item) =>
                item.from_currency_code === "ETH" &&
                item.to_currency_code === "USD"
            )?.bid_amount;
            data?.wallets?.cryptos.push({
              id: null,
              currencyCode: "ETH",
              baseCurrencyCode: "USD",
              currencyRate: rate,
              originBalance: 0,
              balance: 0,
              freezeBalance: 0,
            });
          }
          Object.entries(data.wallets).forEach(([key, value]) => {
            wallets[key] =
              value?.map((wallet) => ({
                ...wallet,
                id: wallet?.id,
                dog_food: wallet?.originBalance,
                local_balance: wallet?.balance,
                freeze_dog_food: wallet?.freezeBalance,
                currency_rate: wallet?.currencyRate,
                currency_code: wallet?.currencyCode,
                source: wallet?.source,
              })) ?? [];
          });
          setDataDashboard({ ...data, reports, wallets });
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <>
      <Container className="home-top-bg">
        <ContainerView background="transparent" className="min-height-385">
          <p className="text-[18px] lg:text-[22px] xls:text-[28px] font-[600] leading-[32px] text-[#ffffff] capitalize">
            {replaceString(T("Hello {user}"), "{user}", user.name)},
          </p>
          <p className="text-[14px] lg:text-[16px] xls:text-[20px] font-[400] leading-[30px] text-[#ffffff]">
            {T("Welcome Back!")}
          </p>
          <HomeGuide />
        </ContainerView>
      </Container>
      <Container>
      <ContainerView background="transparent">
        <SlideBannerContainer className="mt-5 lg:mt-10 gap-4 showOver min-h-[100px]">
          <SwiperWraper
            slidesPerView={getSlidePreview()}
            spaceBetween={getSpaceBeetween()}
            grabCursor={true}
            pagination={false}
            watchOverflow={true}
            onSwiper={(s) => {
              setSwiper(s);
            }}
          >
            {dataDashboard?.reports?.map((report, index) => {
              const money = convertToCurrency(
                report.currentTotalBalance || 0,
                dataDashboard?.baseCurrencyCode,
                currency
              );
              const { num, suffix } = formatNumberShort(money);
              
              return (
                <SwiperSlide key={index}>
                  <CardSlideHeader
                    isMobile={isMobile}
                    onClick={() => handleTab(TabHomeOption[report.code])}
                    active={tab === TabHomeOption[report.code]}
                    type={index + 1}
                    title={report.title}
                    balance={
                      <NumberFormat
                        value={num}
                        displayType={"text"}
                        thousandSeparator={thousandSeparatorByCurrency(getCurrency())}
                        decimalSeparator={decimalSeparatorByCurrency(getCurrency())}
                        prefix={prefixCcySymbol(true, getCurrency())}
                        suffix={suffix}
                        decimalScale={decimalScaleByCurrency(
                          baseCurrencyCode(true, getCurrency())
                        )}
                      >
                      </NumberFormat>
                    }
                    infoIcon={
                      report.code === TabHomeOption.asset ? (
                        <Tooltip
                          trigger={size.width < 768 ? "click" : "hover"}
                          onClick={(e) => e.stopPropagation()}
                          className="cursor-pointer"
                          color={"#EAF2FF"}
                          overlayClassName={"note-tooltip"}
                          title={T(
                            "Total profitable assets include purchase value of earners and tradeable characters."
                          )}
                        >
                          <span>
                            <InfoTooltipIcon />
                          </span>
                        </Tooltip>
                      ) : report.code === TabHomeOption.affilate ? (
                        <Tooltip
                          trigger={size.width < 768 ? "click" : "hover"}
                          onClick={(e) => e.stopPropagation()}
                          className="cursor-pointer"
                          color={"#EAF2FF"}
                          placement={size.width < 1024 ? "bottom" : "top"}
                          overlayClassName={"note-tooltip-3"}
                          title={
                            <div>
                              <div style={{ marginBottom: "10px" }}>
                                {T(
                                  "Unrealized Commission is the commission that not yet finalized and convertible. The current Unrealized commission is calculated from {batch_run_date}"
                                ).replace(
                                  "{batch_run_date}",
                                  getBatchRunDate()
                                )}
                              </div>
                              <span>
                                {T(
                                  "Unrealized Commission of the current month will be converted to Realized Commission for the next month at 25th and you can withdraw the commission from AMS after that."
                                )}
                              </span>
                            </div>
                          }
                        >
                          <span>
                            <InfoTooltipIcon />
                          </span>
                        </Tooltip>
                      ) : null
                    }
                    bannerIcon={bannerIcon[report.code]}
                  />
                </SwiperSlide>
              );
            })}
          </SwiperWraper>
        </SlideBannerContainer>
        <TabsCustom
          spaceItem={size.width > 1024 ? 32 : 30}
          className="v2 mt-[18px] lg:mt-[40px] xls:[54px]"
          activeKey={tab}
          onChange={(e) => handleTab(e)}
        >
          <Tabs.TabPane tab={T("Wallet")} key={TabHomeOption.wallet}>
            <TabWallet data={dataDashboard?.wallets} />
          </Tabs.TabPane>

          <Tabs.TabPane tab={T("Asset")} key={TabHomeOption.asset}>
            <TabAsset />
          </Tabs.TabPane>

          <Tabs.TabPane tab={T("Earn")} key={TabHomeOption.earn}>
            <TabEarn />
          </Tabs.TabPane>
        </TabsCustom>
      </ContainerView>
    </Container>
    </>
  );
};
